module.exports = __webpack_public_path__ + "img/iphone-6-white.1103881a.png";